import RCAStatusBadge from "pages/Corporate/RCA/components/RCAStatusBadge";
import { useStyles } from "./RCALibraryStatusCell.styles";
import { IRCALibraryStatusCell } from "./RCALibraryStatusCellInterfaces";
import { useTranslation } from "react-i18next";
import { DefaultTranslationFieldsInTable } from "constants/constants";
import { translateDefaultEntity } from "utilities/localesUtilities";

const RCALibraryStatusCell = ({ rca, myDashboard }: IRCALibraryStatusCell) => {
    const classes = useStyles();
    const { i18n } = useTranslation();
    return (
        <div className={myDashboard ? classes.myDashboardWrapper : classes.wrapper}>
            <div className={classes.statusWrapper}>
                <RCAStatusBadge status={rca.status?.status_id as unknown as number} className={classes.statusBadge} />{" "}
                <span>
                    {translateDefaultEntity(i18n.language, rca.status, "name", DefaultTranslationFieldsInTable.STATUS)}
                </span>
            </div>
        </div>
    );
};

export default RCALibraryStatusCell;
